import { render, staticRenderFns } from "./current_limit.vue?vue&type=template&id=46ce2037&scoped=true&"
import script from "./current_limit.vue?vue&type=script&lang=js&"
export * from "./current_limit.vue?vue&type=script&lang=js&"
import style0 from "./current_limit.vue?vue&type=style&index=0&id=46ce2037&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ce2037",
  null
  
)

export default component.exports